<template>
  <div class="videoWrap">
    <video id="fxTcplayer" preload="auto" playsinline webkit-playsinline></video>
    <div :class="['poster', isShowPoster ? 'realShow' : 'realHide']">
      <img :src="posterSrc" alt="" />
    </div>
  </div>
</template>
<script>
import { getVideoInfo, getWXConfig, addPv } from '@api/video'
import wxSetting from '@components/common/wxSetting'

export default {
  data() {
    return {
      isShowPoster: false,
      posterSrc: ''
    }
  },
  mixins: [wxSetting],
  methods: {
    getVideoInfo(id) {
      getVideoInfo({
        id: id || ''
      })
        .then(({ data, status }) => {
          if (status === 200 && data.code === 0) {
            const { fileId: fileID, appID, overLink, overPic, overContent, shareTitle } = data.data
            document.title = shareTitle
            var player = TCPlayer('fxTcplayer', {
              fileID,
              appID
            })
            let endFunc = () => {}
            switch (overContent) {
              // 跳转链接
              case 0:
                if (overLink) {
                  endFunc = () => {
                    location.href = overLink
                  }
                }
                break
              // 展示图片
              case 1:
                if (overPic) {
                  this.posterSrc = overPic
                  endFunc = () => {
                    this.isShowPoster = true
                  }
                }
                break
              default:
                break
            }
            player.on('ended', endFunc)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
  },
  mounted() {
    document.body.style.cssText += 'min-width: 100%;'

    const id = this.$route.query.id

    // 请求视频详情
    this.getVideoInfo(id)
    // 添加浏览量
    addPv({ id: id }).then((res) => {})

    // 初始化微信设置
    this.shareUrl = window.location.href.split('#')[0]
    let ua = window.navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      const wxParams = {
        id: id,
        currentUrl: this.shareUrl
      }
      this.getWXConfig(wxParams, getWXConfig)
    } else {
      console.log('不是微信浏览器')
    }

    if (this.isMobile) {
      // 移动端微信浏览器拖动书刊区域时禁止下拉
      document.querySelector('.book-content-wrapper').addEventListener(
        'touchmove',
        function(e) {
          e.preventDefault()
        },
        { passive: false }
      )
    }
  }
}
</script>
<style lang="scss">
.videoWrap {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .tcplayer {
    margin: 0 auto;
  }
  /* 通过 css 设置播放器尺寸 这时<video>中的宽高属性将被覆盖*/
  #fxTcplayer {
    width: 100%;
    height: 100%;
    overflow: hidden;
    .vjs-fullscreen-control {
      display: none;
    }
  }
  .poster {
    position: absolute;
    top: 0;
    height: 100%;
    background: white;
    z-index: 1;
    transition: 0.7s all;
    display: flex;
    width: 100%;
    > img {
      width: 100%;
      align-self: center;
    }
  }
  .realShow {
    left: 0;
  }
  .realHide {
    left: -101%;
  }
}
</style>
